import { pluralize } from "./string"

export function roundToNearest(value: number, n: number) {
  return Math.round(value / n) * n
}

/** 120 => 2h, 150 => 2h30 */
export function formatMinutes(minutes: number) {
  const hours = Math.floor(minutes / 60)
  const min = Math.floor(minutes % 60)
  return pluralize(hours, `%c hour%s${min ? pluralize(min, ` %c minute%s`) : ""}`)
}

export function sum(values: number[]) {
  return values.reduce((a, b) => a + b, 0)
}
